import React, { useState } from 'react';
import {
  Button,
  FormInput,
  FormNumber,
  FormSelect,
  FormSubmitButton,
  FormSwitch,
  MasterDetailForm,
  Row,
} from '@digital/ui';
import { Modal } from 'antd';
import { ClassificacaoServico, update } from '@app/api/classificacaoServico';

interface Props {
  idPai: string | null;
  item: ClassificacaoServico | null;
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  onUpdate: () => void;
  setItem: React.Dispatch<React.SetStateAction<ClassificacaoServico | null>>;
}
const ModalUpdateItem = (props: Props) => {
  const { idPai, item, showModal, setShowModal, onUpdate, setItem } = props;
  const [clear, setClear] = useState(false);

  const submit = (values: any) => {
    update({ ...values, itemPaiId: idPai }).then(data => {
      if (data.valid) {
        setShowModal(false);
        onUpdate();
        setItem(null);
        setClear(true);
        setClear(false);
      }
    });
  };

  return (
    <>
      <Modal visible={showModal} width="960px" onCancel={() => setShowModal(false)} footer={null}>
        {!clear && (
          <MasterDetailForm
            initialValues={item}
            onSubmit={submit}
            actions={[
              <Button type="link" onClick={() => setShowModal(false)}>
                Cancelar
              </Button>,
              <FormSubmitButton type="primary" noIcon>
                Salvar
              </FormSubmitButton>,
            ]}>
            <Row style={{ padding: '20px' }}>
              <Row>
                <FormInput name="nome" label="Nome" span={12} required />
              </Row>
              <Row>
                <FormInput name="descricao" label="Descrição" span={12} required />
              </Row>
            </Row>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};
export default ModalUpdateItem;
